import { useState, useEffect } from 'react'

interface useNotificationModalProps {
  open: boolean
  onOpen?: () => void
}

interface useNotificationModalReturn {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
}

export default function useNotificationModal({
  open,
  onOpen,
}: useNotificationModalProps): useNotificationModalReturn {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    setIsOpen(open)
    /* eslint-disable no-unused-expressions */
    if (open) onOpen ? onOpen() : null
  }, [open])

  return {
    isOpen,
    setIsOpen,
  }
}
